import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { Controller } from 'react-hook-form';
import Select from 'react-select';

const ChangePriorityModal = ({ show, handleClose, handleSubmit, control, priority, onSubmit, errors }) => {
  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Change Task Priority</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="col-12 col-md-12">
            <div className="form-group pb-4">
              <Controller
                name="priority"
                control={control}
                rules={{ required: "Priority is required" }}
                render={({ field }) => (
                  <Select
                    {...field}
                    options={priority}
                  />
                )}
              />
              {errors.priority && <div className="invalid-feedback">{errors.priority.message}</div>}
            </div>
          </div>
          <div className="modal-footer">
            <Button variant="danger" size='sm' onClick={handleClose}>Cancel</Button>
            <Button type="submit" size='sm' variant="primary">Save</Button>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
};

export default ChangePriorityModal;
